<template>
  <!-- 资讯动态 -->
  <div class="dynamic">
    <div v-if="this.$route.path == '/mobile/dynamic'">
      <!-- 顶部导航 -->
      <TopNav></TopNav>
      <!-- 资讯动态轮播图 -->
      <DynamicBanner></DynamicBanner>
      <!-- 资讯动态 -->
      <News></News>
      <!-- 底部导航 -->
      <BottomNav></BottomNav>
    </div>
    <div v-else>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import TopNav from "../../../components/mobile/components/TopNav.vue";
import BottomNav from "../../../components/mobile/components/BottomNav.vue";
import DynamicBanner from "../../../components/mobile/Dynamic/DynamicBanner.vue";
import News from "../../../components/mobile/Dynamic/News.vue";

export default {
  setup() {
    return reactive({});
  },
  components: {
    TopNav,
    BottomNav,
    DynamicBanner,
    News,
  },
};
</script>

<style scoped>
</style>
